import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles';

const useStyles = createUseStyles(
  {
    root: {
      marginTop: 24,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 12,
    },
    title: {
      color: 'var(--x-text-color-1)',
      fontWeight: FontWeight.SemiBold,
      fontSize: 12,
      lineHeight: '24px',
    },
    starsContainer: {
      padding: [2, 0],
      display: 'flex',
      gap: 8,
    },
    starts: {
      display: 'flex',
      gap: 2,
    },
    review: {
      color: 'var(--x-text-color-1)',
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: FontWeight.SemiBold,
    },
    noOfReviews: {
      color: 'var(--x-textf-field-color-1)',
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: FontWeight.Medium,
    },
  },
  {
    name: 'reviews',
  },
);

export default useStyles;
